import MomentsUploadForm from './MomentsUploadForm';

const DefaultMomentsUploadForm = props => {
  const {
    onClose,
    action,
    onSubmit,
    job
  } = props;

  let jobId = job.id;
  let isDefault = true;
  let storyIds = [job.template_story_id];
  let hideJobSelect = true;
  let hideDefaultCheckbox = true;
  let hideCustomerSelect = true;

  return <MomentsUploadForm {...{
    onClose,
    action,
    onSubmit,
    jobId,
    isDefault,
    storyIds,
    hideJobSelect,
    hideDefaultCheckbox,
    hideCustomerSelect
  }} />;
}

export default DefaultMomentsUploadForm;
